import { create } from 'zustand';
import i18n from 'i18n';
import { ApiUtils, TransactionsApi, type GetCardTransactionsRequest, type GetCardTransactionsResponse } from '@shared/api';

interface UseCardTransactionsStore {
  loading: boolean;
  subLoading: boolean;
  data: GetCardTransactionsResponse | null;
  hasNext: boolean;
  error: string | null;
  getCardTransactions: (request: GetCardTransactionsRequest) => Promise<void>;
  clear: () => void;
}

export const useCardTransactionsStore = create<UseCardTransactionsStore>((set) => ({
  loading: false,
  subLoading: false,
  data: null,
  hasNext: false,
  error: null,

  getCardTransactions: async (request) => {
    const isInitialLoad = request.index === 0 || !request.index;

    try {
      set({ loading: isInitialLoad, subLoading: !isInitialLoad, error: null });
      const result = await TransactionsApi.getCardTransactions(request);
      set((prev) => ({
        loading: false,
        subLoading: false,
        hasNext: request.count <= result.totalCount,
        data: isInitialLoad ? result || null : { ...result, data: [...(prev.data?.data || []), ...(result?.data || [])] },
      }));
    } catch (error) {
      set({ loading: false, subLoading: false, error: i18n.t(`errors.api.${ApiUtils.getError(error)}`, ApiUtils.getError(error)) });
    }
  },

  clear: () => set({ loading: false, subLoading: false, data: null, hasNext: false, error: null }),
}));
